import SchoolLayout from '@/routes/SchoolApp/layout/SchoolLayout';
import SchoolSideBar from '@/routes/SchoolApp/layout/SchoolSideBar';

export default SchoolLayout;

export { SchoolSideBar };
